import { deserialize, inheritSerialization, serialize } from "cerialize";

import BaseEntity from "./BaseEntity";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";

@inheritSerialization(BaseEntity)
export default class Kegiatan extends BaseEntity {

  @serialize
  @deserialize
  public id: number = 0;

  @serialize
  @deserialize
  public nama: string = "";

  @serialize
  @deserialize
  public kode: string = "";

  @serialize
  @deserialize
  public jenis: string = "";

  @serialize
  @deserialize
  public waktu_sholat: string = "";

  @serialize
  @deserialize
  public jenis_kelamin: string = "";

  @serialize
  @deserialize
  public wilayah: string = "";

  @serialize
  @deserialize
  public waktu_mulai: string = "";

  @serialize
  @deserialize
  public waktu_selesai: string = "";

  @serialize
  public keterangan: string = "";

  @deserialize
  public deskripsi: string = "";

  @serialize
  @deserialize
  public is_active: boolean = true;

  @serialize
  public filter: any = {
    wilayah: "",
    pengajian: "",
    komplek: "",
    kamar: ""
  };

  @serialize
  @deserialize
  public pengajians: Array<any> = [];

  public file: any = null;

  public namaFeedback() {
    return this.defaultPropertyFeedback("nama");
  }

  public jenisFeedback() {
    return this.defaultPropertyFeedback("jenis");
  }

  public jenisKelaminFeedback() {
    return this.defaultPropertyFeedback("jenis_kelamin");
  }

  public wilayahFeedback() {
    return this.defaultPropertyFeedback("wilayah");
  }

  public fileFeedback() {
    return this.defaultPropertyFeedback("file", Boolean(this.file));
  }

  public waktuSelesaiFeedback() {
    // Validasi waktu_selesai tidak boleh lebih kecil dari waktu_mulai
    if (!this.waktu_mulai || !this.waktu_selesai) {
      return { valid: true, type: 'success', message: '' };
    }

    // Konversi waktu dari format HH:mm ke menit untuk perbandingan
    const parseTime = (timeStr: string): number => {
      if (!timeStr) return 0;
      const [hours, minutes] = timeStr.split(':').map(Number);
      return hours * 60 + minutes;
    };

    const waktuMulaiMenit = parseTime(this.waktu_mulai);
    const waktuSelesaiMenit = parseTime(this.waktu_selesai);

    const valid = waktuSelesaiMenit > waktuMulaiMenit;
    const message = valid ? '' : 'Waktu selesai harus lebih besar dari waktu mulai';
    const type = valid ? 'success' : 'danger';

    return { valid, type, message };
  }

  public table() {
    const {
      nama,
      jenis,
      waktu_sholat,
      waktu_mulai,
      waktu_selesai,
      is_active
    } = this;

    return {
      nama,
      jenis,
      waktu_sholat,
      waktu_mulai,
      waktu_selesai,
      is_active
    };
  }

  public static columnName(): Array<TableColumn> {
    const table = new Kegiatan().table();
    const keys = Object.keys(table);

    return keys.map((field: string) => {
      const tableColumn = new TableColumn();
      tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

      // Center align untuk kolom jenis, waktu_sholat, waktu_mulai, waktu_selesai, dan is_active
      if (field === "jenis" || field === "waktu_sholat" || field === "waktu_mulai" || field === "waktu_selesai" || field === "is_active") {
        tableColumn.position = "centered";
      }

      return tableColumn;
    });
  }
}


